module.exports = __webpack_public_path__ + "school/img/wudafazhan.84aa5ee8.png";